import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ReservationAllowanceState {
  isAllowed: boolean;
  isLoading: boolean;
  error: string | null;
}

const initialState: ReservationAllowanceState = {
  isAllowed: false,
  isLoading: false,
  error: null,
};

const reservationAllowanceSlice = createSlice({
  name: 'reservationAllowance',
  initialState,
  reducers: {
    setReservationAllowance: (state, action: PayloadAction<boolean>) => {
      state.isAllowed = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setReservationAllowanceLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setReservationAllowanceError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  setReservationAllowance,
  setReservationAllowanceLoading,
  setReservationAllowanceError,
} = reservationAllowanceSlice.actions;

export default reservationAllowanceSlice.reducer;
